const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryStoreCameraList({ rootState }, params = {}) {
      const data = await rootState.http("/transparent/workshop/queryCClientDeviceList", params);
      return data;
    },
    async queryCameraVideoUrl({ rootState }, params = {}) {
      const data = await rootState.http("/transparent/workshop/findRealTimeVideoAddress", params);
      return data;
    },
    async updateMediaHeartbeat({ rootState }, params = {}) {
      const data = await rootState.http("/transparent/workshop/mediaHeartbeat", params);
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/live.js